var styleDataHash = "b8c29ef5";
const injectCss = (() => {
  var css = `.lKEHp{background-color:var(--ricos-settings-dividers-color,rgba(51,51,51,.2));margin-block:6px;margin-inline:24px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var list_item_divider_default = {
  "divider": "lKEHp"
};
export {
  list_item_divider_default as default,
  injectCss
};
//# sourceMappingURL=list-item-divider-scss.js.map
